import styled from 'styled-components';
import { SearchBlock } from '@groupby/ui-components';
export const StyledSearchBlock = styled(SearchBlock) `
  & .MuiInputBase-root {
    height: 60px;
  }
`;
